var render, staticRenderFns
import script from "./BButton.vue?vue&type=script&lang=js&"
export * from "./BButton.vue?vue&type=script&lang=js&"
import style0 from "./BButton.vue?vue&type=style&index=0&id=7c953c72&scoped=true&lang=css&"
import style1 from "./BButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c953c72",
  null
  
)

export default component.exports